import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { TextRegionTileFragment } from "../../client/generated";
import { assertTypeName } from "../../client/guards";
import { stripHtmlTags } from "../../rich-text/utils";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: TextRegionTileFragment;
  textAttributeId: string;
  children?: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function TextRegionTile({
  fragment,
  textAttributeId,
  children,
  dispatch,
}: Props) {
  const textAttribute = fragment.attributes.find(
    (a) => a.id === textAttributeId,
  );
  assertTypeName(textAttribute?.__typename === "TextAttribute");

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile
      fragment={fragment}
      preview={stripHtmlTags(textAttribute.text)}
      onClick={onClick}
    >
      {children}
    </RegionTile>
  );
}
